import React, { memo } from "react";
import useExpandableGridCell from "./index.hooks";
import { Paper, Popper, Typography } from "@material-ui/core";

type ExpandableGridCellProps = {
  value: string;
  width: number;
}

const ExpandableGridCell = ({value, width}: ExpandableGridCellProps) => {
  const {
    styles,
    handleMouseEnter,
    handleMouseLeave,
    wrapper,
    cellValue,
    anchorEl,
    showPopper,
    cellDiv,
    showFullCell,
  } = useExpandableGridCell();

  return (
    <div
      ref={wrapper}
      className={styles.root}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        ref={cellDiv}
        style={{
          height: 1,
          width,
          display: 'block',
          position: 'absolute',
          top: 0,
        }}
      />
      <div ref={cellValue} className="cellValue">
        {value}
      </div>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current!.offsetHeight - 3 }}
          >
            <Typography variant="body2" className={styles.valueStyle}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </div>
  );
};

export default memo(ExpandableGridCell);
